export type FocalAnchor = { imageFocalX?: number; imageFocalY?: number } | null | undefined

/**
 * `background-position` for an event cover or artist image: the doc's detected
 * focal point when it has one, else the surface's own tuned anchor.
 */
export function focalPosition(doc: FocalAnchor, fallback: string): string {
  const x = doc?.imageFocalX
  const y = doc?.imageFocalY
  return typeof x === 'number' && typeof y === 'number' ? `${x}% ${y}%` : fallback
}
